import { AxiosResponse } from 'axios'

import { instanceMainService, transformPayload, TransformPayloadReturnT } from 'primsell-shared-layer/api'
import {
  IBuyerIdentity,
  IBuyerIdentityActivity,
  IBuyerInfo,
  IGetBuyerActivityListRequest,
  IGetBuyersIdentitiesListRequest,
  IIdentityAndStatistic,
  IRequestGetAccessToken,
  IRequestGetNonce,
  IResponse,
  IResponseGetAccessToken,
  IResponseGetNonce,
  WrappedResponse,
} from 'primsell-shared-layer/types'

import { BUYER_URLS } from './buyer.constants'
import { replaceUrlParams } from 'primsell-shared-layer/utils'

export class BuyerAPI {
  static getBuyersData(): Promise<WrappedResponse<IBuyerInfo>> {
    return instanceMainService.get(BUYER_URLS.ME)
  }

  static getBuyerIdentities(payload: IGetBuyersIdentitiesListRequest): Promise<WrappedResponse<IBuyerIdentity[]>> {
    const transformedPayload: TransformPayloadReturnT = transformPayload(payload)

    return instanceMainService.get(BUYER_URLS.BUYER_IDENTITIES, { params: transformedPayload })
  }

  static getBuyerIdentitiesStatistic(id: string): Promise<WrappedResponse<IIdentityAndStatistic>> {
    return instanceMainService.get(replaceUrlParams(BUYER_URLS.BUYER_IDENTITIES_STATISTIC, { id }))
  }

  static getToken(payload: IRequestGetAccessToken): Promise<AxiosResponse<IResponse<IResponseGetAccessToken>>> {
    return instanceMainService.post(BUYER_URLS.GET_TOKEN, payload)
  }

  static getNonce(payload: IRequestGetNonce): Promise<AxiosResponse<IResponse<IResponseGetNonce>>> {
    return instanceMainService.post(BUYER_URLS.GET_NONCE, payload)
  }

  static getBuyerIdentitiesCSV(
    payload: Exclude<IGetBuyersIdentitiesListRequest, 'pagination'>
  ): Promise<AxiosResponse<string>> {
    const transformedPayload: TransformPayloadReturnT = transformPayload(payload)

    return instanceMainService.get(BUYER_URLS.BUYERS_CSV, { params: transformedPayload })
  }

  static getBuyerActivity(payload: IGetBuyerActivityListRequest): Promise<WrappedResponse<IBuyerIdentityActivity[]>> {
    const transformedPayload: TransformPayloadReturnT = transformPayload(payload)

    return instanceMainService.get(replaceUrlParams(BUYER_URLS.BUYER_ACTIVITY, { id: payload.id }), {
      params: transformedPayload,
    })
  }
}
